import BadgeIcon from "@mui/icons-material/Badge";
import { IconButton } from "@mui/material";
import WindowService from "../../services/windowService";

/**
 * Button component that opens the client passport dialog
 */
export const ClientPassportButton = ({ clientId, clientType, size, color = "primary" }) => {
    const handleClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        if (clientType === "customer") {
            WindowService.openInNewTab(`/customers/passport-window/${clientId}/`);
        } else if (clientType === "company") {
            WindowService.openInNewTab(`/companies/passport-window/${clientId}/`);
        }
    };

    return (
        <IconButton color={color} onClick={handleClick} size={size}>
            <BadgeIcon />
        </IconButton>
    );
};
